import * as yup from 'yup';

import i18n from '@app/i18n/config';

export const standardsAgreementSchema = yup
  .object()
  .shape({
    standardsAgreement: yup
      .bool()
      .required(i18n.t('COMMON:errors.required'))
      .oneOf([true], i18n.t('COMMON:errors.required')),
  })
  .required();
